export default __webpack_public_path__ + "static/media/login-background.d22a251e.webp";